import React, { useCallback } from 'react'
import { Button } from 'react-bootstrap'
import { useDropzone } from 'react-dropzone'
import classNames from 'classnames'
import S from './LoadProject.module.scss'

export default function LoadProject({ onProjectSelected, setLoadingError, compact = false }) {
  const onDrop = useCallback(
    (acceptedFiles) => {
      const reader = new FileReader()
      reader.addEventListener('load', (e) => {
        try {
          setLoadingError(null)
          Promise.resolve(onProjectSelected(e.target.result)).catch((err) => {
            setLoadingError(err.message)
          })
        } catch (e) {
          setLoadingError(e.message)
        }
      })
      if (acceptedFiles.length) {
        reader.readAsText(acceptedFiles[0])
      }
    },
    [onProjectSelected, setLoadingError]
  )
  const {
    getRootProps,
    getInputProps,
    isDragReject,
    isDragAccept,
  } = useDropzone({
    onDrop,
    accept: '.lugsail,.rawgraphs',
    maxFiles: 1,
  })
  if (compact) {
    return (
      <div className={S.compact} {...getRootProps()}>
        <input {...getInputProps()} />
        <div>
          <strong>Resume a saved project</strong>
          <span>Restore the chart, data, and styling from a .lugsail file.</span>
        </div>
        <button type="button" className={S.compactButton}>Open project</button>
      </div>
    )
  }

  return (
    <div
      className={classNames(S.dropzone, {
        [S.reject]: isDragReject,
        [S.accept]: isDragAccept,
      })}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <span>Drag a file here or </span>
      <Button className={S['browse-button']} color="primary">
        Browse
      </Button>
      <span>a file from your computer</span>
      {isDragAccept && <p>All files will be accepted</p>}
      {isDragReject && <p>Some files will be rejected</p>}
    </div>
  )
}
